// extracted by mini-css-extract-plugin
module.exports = {"ingres":"_1y8Z5Y","attemptedPath":"_2Ialg4","secondTitle":"_3WaQjP"};